import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { AccountState } from './types'

export const getters: GetterTree<AccountState, RootState> = {
  token (state) {
    return state.access_token
  },
  errors (state) {
    return state.error
  },
  passwordUpdated (state) {
    return state.passwordUpdate
  },
  alertUpdated (state) {
    return state.alertUpdate
  },
  alertaCorreo (state) {
    return state.alerta_correo
  },
  alertaMovil (state) {
    return state.alerta_movil
  }
}
